import * as Type from './actionsTypes';

const fetchRelatorioJobsPreview = () => ({ type: Type.RELATORIO_JOB_FETCH_PREVIEW });

const startRelatorioAuditoriaFaixa = (nsirId) => ({
  type: Type.RELATORIO_JOB_START_AUDITORIA_FAIXA,
  nsirId,
});

const downloadRelatorioJob = (job) => ({
  type: Type.RELATORIO_JOB_DOWNLOAD,
  job,
});

const cleanRelatorioJobs = () => ({ type: Type.RELATORIO_JOB_CLEAN });

export {
  fetchRelatorioJobsPreview,
  startRelatorioAuditoriaFaixa,
  downloadRelatorioJob,
  cleanRelatorioJobs,
};
